// Show/hide additional info
jQuery(document).ready(function($) {
    $('.person-info .show-additional').click(function(event) {
        console.log('clicked');
        event.preventDefault();
        $(this).closest('.person-info').css('height', '100%').css('overflow-y', 'auto');
        $(this).closest('.person-info').find('.additional').addClass('open').fadeIn();
        $(this).closest('.person-info').find('.overlay').css('overflow-y', 'auto');
        $(this).closest('.person-info').find('.hide-additional').fadeIn();
        $(this).hide();
    });
    $('.person-info .hide-additional').click(function(event) {
        event.preventDefault();
        console.log('click');
        $(this).closest('.person-info').css('height', 'auto').css('overflow-y', 'initial');
        $(this).closest('.person-info').find('.additional').removeClass('open').hide();
        $(this).closest('.person-info').find('.overlay').css('overflow-y', 'initial');
        $(this).closest('.person-info').find('.show-additional').show();
        $(this).hide();
    });
});  